import React, { Component } from 'react'
import moment from 'moment'

import { StatusItem, StatusItemValue, StatusItemClear } from './Status.styles'

import { Icon } from '../../../shared/tr-icons'

class StatusItemContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayValue: this.parseValues(props)
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      displayValue: this.parseValues(props)
    })
  }

  handleRemoveClick = (evt) => {
    evt.preventDefault()

    if (this.props.type === 'customfilter') {
      this.props.handleRemoveFilter(null)
      this.props.api.setCustomFilter(null)
      this.props.api.setCustomFilterId(null)
      this.props.api.setCustomFilterType(null)
    } else {
      this.props.handleRemoveFilter({
        handle: this.props.handle
      })
      if (this.props.api) {
        this.props.api.setCustomFilter(null)
        this.props.api.setCustomFilterId(null)
        this.props.api.setCustomFilterType(null)
      }
    }
  }

  parseValues(props) {
    if ((props.type === 'list' || props.type === 'select' || props.type === 'treeView') && Array.isArray(props.values)) {
      const multiSelectvaluesArray = props.values.map((item) => {
        return item.label
      })

      return `in ${multiSelectvaluesArray.join(' or ')}`
    }

    if (props.type === 'daterange') {
      return `from ${moment(props.values.startDate).format('DD/MM/YYYY')} to ${moment(props.values.endDate).format('DD/MM/YYYY')}`
    }

    if (props.type === 'datesingle') {
      return `${moment(props.values).format('DD/MM/YYYY')}`
    }

    if (props.type === 'dateselector' && props.values.date !== null && props.values.date !== undefined) {
      return `${moment(props.values.date).format('DD/MM/YYYY')}`
    }

    if (props.type === 'dateselector' && props.values.startDate !== null && props.values.endDate !== undefined) {
      return `from ${moment(props.values.startDate).format('DD/MM/YYYY')} to ${moment(props.values.endDate).format('DD/MM/YYYY')}`
    }

    if (props.type === 'customfilter') {
      return props.customFilter
    }

    return props.values
  }

  render() {
    return (
      <StatusItem data-testid='status-filteritem'>
        {this.props.column !== '' &&
        <span>
          {this.props.title}:&nbsp;
        </span>
        }
        {(this.props.values || this.props.customFilter) &&
          <StatusItemValue data-testid='status-itemvalue'>{this.state.displayValue}</StatusItemValue>
        }
        <StatusItemClear onClick={this.handleRemoveClick}>
          <Icon type='clearOutline' baseColor='white' />
        </StatusItemClear>
      </StatusItem>
    )
  }
}

export default StatusItemContainer
